import React, { memo, useMemo } from 'react';
import styles from '../../OrderStatusPage.module.scss';
import { useLocation } from 'react-router-dom';
import {
  displayTime,
  getDateLabel,
  MyCheckApp,
  useLocationStore,
  useTranslation,
} from 'mycheck-core';
import get from 'lodash/get';
import classnames from 'classnames';
import { Spacer, TranslateText } from '@components';
import { OrderStatusName } from 'plugins/CheckoutPlugin/types/CheckoutTypes';
import { OrderStatusNameUIMapper } from '../OrderStatusTracker/helpers';

interface OrderStatusDescriptionProps {
  title: OrderStatusName;
  orderId: number;
  dueTime: string;
}

const OrderStatusDescription: React.FC<OrderStatusDescriptionProps> = ({
  title,
  orderId,
  dueTime,
}) => {
  const location = useLocation();
  const LocationStore = useLocationStore();
  const { t } = useTranslation();
  const config = useMemo(() => {
    const _config = MyCheckApp.instance.getGlobalConfig();

    const primary = get(_config, 'palette.primary', {});

    return {
      primary,
    };
  }, [location.search]);

  const titleColour =
    title === OrderStatusName.CANCELLED ? '#BB0E2D' : config.primary;

  const formattedTitle = OrderStatusNameUIMapper(title);
  const titleAppendix =
    title === OrderStatusName.PREPARING_NOT_PAID ||
    title === OrderStatusName.READY_NOT_PAID;

  return (
    <>
      <div
        className={styles.orderStatusPageTitle}
        style={{
          color: titleColour,
        }}
      >
        {t(`orderStatus.figure.statuses.${formattedTitle}`)}&nbsp;
        {titleAppendix && t(`orderStatus.figure.statuses.paymentPending`)}
      </div>
      <div
        className={styles.orderStatusPageSeeBelow}
        style={{
          color: titleColour,
        }}
      >
        {t('orderStatus.seeBelow')}
      </div>
      <div className={styles.orderStatusPageSubtitle}>
        <TranslateText
          tKey="orderStatus.subtitle"
          values={{
            when: getDateLabel(
              dueTime,
              LocationStore.locationTimezoneName,
              'h:mm a',
            ),
            at: displayTime(
              dueTime,
              LocationStore.locationTimezoneName,
              'h:mm a',
            ),
          }}
        />
      </div>
      <div
        className={classnames(
          styles.orderStatusPageSubtitle,
          styles.orderStatusPageOrder,
        )}
      >
        {t('orderStatus.subtitleOrderTime', {
          orderId,
        })}
      </div>
      <Spacer color="#C6C6C6" />
    </>
  );
};

export default memo(OrderStatusDescription);
